<div class="simple-form-aligner">
  <mat-card class="simple-form-card">
    <form [formGroup]="form" (ngSubmit)="submit()">
      <fieldset [disabled]="waiting">
        <mat-card-header>
          <mat-card-title> Create an organization </mat-card-title>
          <mat-card-subtitle>
            Create an organization under your {{ email }} account.
          </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <div class="form-group">
            <mat-form-field class="simple-form-field-100">
              <mat-label>Company/organization name</mat-label>
              <input
                matInput
                type="text"
                placeholder="Company/organization name"
                name="name"
                id="name"
                formControlName="name"
                autocomplete="name"
                required
              />
              <mat-error>Required</mat-error>
            </mat-form-field>

            <section>
              <div class="button-right-container">
                <div></div>
                <div>
                  <div class="spinner-container" *ngIf="waiting">
                    <mat-spinner diameter="24"></mat-spinner>
                  </div>
                  <button
                    mat-raised-button
                    color="primary"
                    [disabled]="waiting"
                    type="submit"
                    value="submit"
                  >
                    Create organization
                  </button>
                </div>
              </div>
              <span *ngIf="formErrorMessage" class="text-error-color">
                {{ formErrorMessage }}
              </span>
            </section>
          </div>
        </mat-card-content>
      </fieldset>
    </form>
  </mat-card>
</div>
